<template>
  <div>
    <a class="thumb-card" @click="loadVideo">
      <img
        id="axis"
        style="width: 198px; height: 128px;"
        :src="src">
    </a>
    <div style="width: 500px; vertical-align: top; display: inline-block;">
      <span class="title" :class="colorClass">{{title}}</span>
      <br/>
      <span class="description">{{description}}</span>  
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "HelpCenterVideo",
  props: {
    id: Number,
    video: String,
    thumbnail: String,
    title: String,
    description: String, 
  },
  computed: {
    ...mapGetters(["knowledgeCenterSettings"]),
    src() {
      return this.knowledgeCenterSettings.legacyEndpoint + "VideoThumbnails/" + this.thumbnail;
    }
  },
  methods: {
    loadVideo(){
      this.$store.dispatch("launchVideo", this.id);
    }
  }
};
</script>

<style lang="scss" scoped>
  .thumb-card ::v-deep {
    margin: 5px;
    position: relative;
    height: 130px;
    width: 200px;
    display: inline-block;
    border: 1px solid $color-grey;

    span {
      position: absolute;
      right: 10px;
      bottom: 10px;
      user-select: none;
    }

    #timespan {
      left: 5px;
    }
    #image-eye {
      .tooltiptext {
        visibility: hidden;
        width: 100px;
        background-color: #616161;
        color: #fff;
        text-align: center;
        border-radius: 6px;

        /* Position the tooltip */
        position: absolute;
        z-index: 1;
      }
      &:hover .tooltiptext {
        visibility: visible;
      }
    }
  }

  .thumb-card:hover{
    background-color: $color-grey;
    cursor: pointer;
  }

  .title {
    vertical-align: top;
    size: 30px;
    font-weight: bold;
  }

  .description {
    vertical-align: top;
    size: 20px;
  }
</style>
